"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardViewIsReadOnly = exports.DashboardViewIsReadOnlyProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DashboardViewIsReadOnlyContext = react_1.default.createContext(false);
DashboardViewIsReadOnlyContext.displayName = "DashboardViewIsReadOnlyContext";
/**
 * @internal
 */
exports.DashboardViewIsReadOnlyProvider = function (_a) {
    var children = _a.children, isReadOnly = _a.isReadOnly;
    return (react_1.default.createElement(DashboardViewIsReadOnlyContext.Provider, { value: isReadOnly }, children));
};
/**
 * @internal
 */
exports.useDashboardViewIsReadOnly = function () {
    return react_1.default.useContext(DashboardViewIsReadOnlyContext);
};
//# sourceMappingURL=DashboardViewIsReadOnlyContext.js.map